var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center", align: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "5" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "v-row",
                        { staticClass: "ma-2", attrs: { justify: "center" } },
                        [_c("h1", [_vm._v(_vm._s(_vm.$t("configure")))])]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-select", {
                            staticClass: "mx-2",
                            attrs: {
                              items: _vm.deviceMode,
                              color: "primary",
                              value: "",
                              label: _vm.$t("deviceMode"),
                              required: "",
                            },
                            model: {
                              value: _vm.deviceModeSelect,
                              callback: function ($$v) {
                                _vm.deviceModeSelect = $$v
                              },
                              expression: "deviceModeSelect",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "address",
                                attrs: {
                                  label: _vm.$t("pinUnlock"),
                                  type: "password",
                                  "ma-0": "",
                                  "pa-0": "",
                                  required: "",
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.pinUnlockPasswordWasChanged = true
                                  },
                                },
                                model: {
                                  value: _vm.pinUnlockPassword,
                                  callback: function ($$v) {
                                    _vm.pinUnlockPassword = $$v
                                  },
                                  expression: "pinUnlockPassword",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c("v-checkbox", {
                            staticClass: "mx-1",
                            attrs: {
                              label: _vm.$t("terminalMode"),
                              color: "primary",
                            },
                            model: {
                              value: _vm.TerminalModeActive,
                              callback: function ($$v) {
                                _vm.TerminalModeActive = $$v
                              },
                              expression: "TerminalModeActive",
                            },
                          }),
                          _vm.TerminalModeActive
                            ? _c("v-text-field", {
                                ref: "address",
                                staticClass: "pl-4",
                                staticStyle: { "max-width": "100px" },
                                attrs: {
                                  label: _vm.$t("timeoutSeconds"),
                                  type: "number",
                                  max: 180,
                                  "ma-0": "",
                                  "pa-0": "",
                                },
                                model: {
                                  value: _vm.seconds,
                                  callback: function ($$v) {
                                    _vm.seconds = $$v
                                  },
                                  expression: "seconds",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { justify: "center", align: "center" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "font-weight-medium mb-2",
                              attrs: { color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.save()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("save")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }